import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=af50f474&scoped=true&"
import script from "./InviteModal.vue?vue&type=script&lang=ts&"
export * from "./InviteModal.vue?vue&type=script&lang=ts&"
import style0 from "./InviteModal.vue?vue&type=style&index=0&id=af50f474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af50f474",
  null
  
)

export default component.exports